export default "__VITE_ASSET__fZkPuWtH__"